<style lang="scss" scoped>
    .breadcrumb {
        font-size: 16px;
        padding: 30px 0;
    }

    .prod-top {
        justify-content: space-between;
    }

    .img-preview {
        width: 450px;
        height: 600px;

        .preview {
            width: 450px;
            height: 450px;
            border: 1px solid #ddd;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .imgs {
            height: 90px;
            margin-top: 20px;

            img {
                width: 75px;
                height: 75px;
                margin: 0;
                border: 1px solid #ddd;
                cursor: pointer;

                &:not(:first-child) {
                    margin-left: 16px;
                }

                &.active {
                    width: 73px;
                    height: 73px;
                    border: 2px solid #90ca6f;
                }
            }

        }
    }

    .prod-base {
        width: 700px;

        .title {
            font-size: 22px;
            font-weight: 500;

            span {
                font-size: 14px;
                font-weight: normal;
                background: #90ca6f;
                color: white;
                padding: 1px 5px;
                margin-right: 15px;
                border-radius: 2px;
            }
        }

        .baseinfo {
            margin-top: 20px;
            background: #f8f8f8;
            padding: 10px 15px;
            line-height: 36px;

            span {
                color: #888;
                margin-right: 20px;
            }

            .price {
                .l {
                    width: 350px;
                    vertical-align: middle;

                    i {
                        vertical-align: middle;
                        font-style: normal;
                        font-size: 26px;
                        font-weight: 600;
                        color: #dc1d20;
                    }
                    .del {
                        text-decoration:line-through;
                        display: inline-block;
                        color: #999;
                        font-size: 12px;
                        margin: 0 0 0 10px;
                        vertical-align: middle;
                    }
                }

                .r {
                    width: 350px;
                    text-align: right;
                    color: #888;
                }
            }
        }

        .row {
            margin-top: 20px;

            label {
                width: 60px;
                padding-left: 15px;
                color: #888;
                line-height: 32px;
            }

            .content {
                flex: 1;

                &.parkpage-items {
                    div {
                        font-size: 16px;
                        border: 1px solid #ddd;
                        cursor: pointer;
                        padding: 15px 15px;

                        &:not(:first-child) {
                            margin-top: 15px;
                        }

                        &.active {
                            border-color: #90ca6f;
                        }
                    }
                }
            }

            .btns {
                padding-top: 10px;

                button {
                    outline: none;
                    border: none;
                    width: 190px;
                    height: 50px;
                    text-align: center;
                    line-height: 50px;
                    font-size: 20px;
                    color: white;
                    cursor: pointer;

                    &.addCar {
                        background: #F9B451;

                        &:hover {
                            background: #F8A221;
                        }
                    }

                    &.noSale {
                        background: #ccc;
                        cursor: default;
                        &:hover {
                            background: #ccc;
                        }
                    }

                    &.buy {
                        background: #E23844;
                        margin-left: 40px;

                        &:hover {
                            background: #DB202E;
                        }
                    }

                    &.beforeSaleBtn {
                        background: #999;
                        color: white;
                    }
                }
            }
        }

        .beforeSale {
            background: #DBE2DB;
            padding-bottom: 10px;

            span {
                margin-left: 30px;
                font-size: 16px;
            }
        }
    }

    .hot {
        width: 1200px;
        border-top: 2px solid #eee;
        margin: 30px auto 0;
        height: 40px;

        span {
            display: block;
            width: 180px;
            height: 30px;
            background: white;
            line-height: 30px;
            font-size: 22px;
            font-weight: 500;
            text-align: center;
            margin: -17px auto 0;

        }
    }

    .hot-items {
        width: 1224px;
        margin: auto;

        .item {
            width: 280px;
            margin: 25px 13px;
            float: left;
            height: 340px;
            padding-top: 20px;
            box-shadow: 0 0 15px #eee;
            text-align: center;

            &:hover {
                box-shadow: 0 0 15px #C9E5B8;
            }

            .title {
                width: 240px;
                margin: 0 auto;
                height: 36px;
                line-height: 36px;
                overflow: hidden;
                padding-top: 10px;
                font-size: 16px;
                padding-bottom: 5px;
            }

            .price {
                color: #F20347;
                font-size: 20px;
            }

            img {
                height: 240px;
                width: 240px;
                display: block;
                margin: auto;
            }
        }
    }

    .detail {
        width: 1200px;
        margin: auto;
        font-size: 16px;
        line-height: 30px;
        text-align: left;
        padding-bottom: 30px;
        
        img {
            border: 0;
            max-width: 1200px;
        }
        ::v-deep p {
            margin: 0;
            padding: 0;
            img {
                display: inherit;
            }
        }
    }

    .detail-items {
        width: 1200px;
        margin: auto;

        .item {
            width: 160px;
            margin: 0px 20px 20px;
            float: left;
            height: 240px;
            text-align: center;

            &:hover {
                box-shadow: 0 0 15px #C9E5B8;
            }

            .title {
                margin: 0 auto;
                height: 36px;
                line-height: 18px;
                overflow: hidden;
                padding-top: 10px;
                font-size: 12px;
                padding-bottom: 5px;
            }

            .price {
                color: #F20347;
                font-size: 16px;
            }

            img {
                height: 160px;
                width: 160px;
                display: block;
                margin: auto;
            }
        }
    }

    .addCarTips {
        text-align: center;

        i {
            font-size: 30px;
            padding: 5px;
            border: 2px solid #90ca6f;
            border-radius: 50px;
            font-weight: 500;
            color: #90ca6f;
        }

        span {
            display: block;
            text-align: center;
            font-size: 20px;
            padding-top: 22px;
            color: #666;
            font-weight: 500;
        }
    }

    .dialog-footer {
        padding-bottom: 35px;

        .jxgw, .ckgwc {
            border: none;
            outline: none;
            height: 44px;
            line-height: 44px;
            font-size: 18px;
            cursor: pointer;
            color: white;
            width: 150px;
            text-align: center;
            background: #F9B451;
        }

        .ckgwc {
            background: #e23844;
            margin-left: 20px;
        }

    }

    ::v-deep .el-dialog__footer {
        padding: 10px 20px 35px;
    }

    ::v-deep .el-input-number__decrease:hover,
    ::v-deep .el-input-number__increase:hover {
        color: #90ca6f;
    }

    ::v-deep .el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled),
    ::v-deep .el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled) {
        border-color: #90ca6f;
    }

    ::v-deep .el-input__inner {
        border-radius: 0;
    }

    :v-deep .el-input__inner:focus {
        border-color: #90ca6f;
        outline: 0
    }

    ::v-deep .el-input.is-active .el-input__inner,
    ::v-deep .el-input__inner:focus {
        border-color: #90ca6f;
        outline: 0
    }
</style>
<style>
    .shopcard_dialog {
        min-width: 400px;
    }
</style>
<template>
    <div>
        <div class="container breadcrumb">
            <router-link to="/">首页</router-link>
            >
            <router-link to="/products">产品中心</router-link>
            >
            {{product.name}}
        </div>
        <div class="container rowflex prod-top">
            <div class="img-preview">
                <div class="preview">
                    <img :src="currImage"/>
                </div>
                <div class="imgs clearfix">
                    <img :class="{active:currImage === img}" @click="currImage = img" v-for="img in product.imageUrls"
                         :src="img"/>
                </div>
            </div>
            <div class="prod-base">
                <div class="title">
                    <span>海淘好货</span>
                    {{product.name}}
                </div>
                <div class="baseinfo">
                    <div class="price rowflex">
                        <div class="l">
                            <span>价　格</span><i>{{ getPriceType(product.priceType).symbol }} {{product.price}}</i>
                            <span class="del">原价：{{ getPriceType(product.priceType).symbol }}{{product.originalPrice}}</span>
                        </div>
                        <div class="r">
                            {{product.name}} x1
                        </div>
                    </div>
                    <div class="other" v-if="product.weight && product.weight > 0">
                        <div><span>重　量</span>{{product.weight}}kg</div>
                        <div v-for="item in product.options"><span>{{item.key}}</span>{{item.value}}</div>
                    </div>
                </div>
                <div class="row rowflex" v-if="product.type ===1 && product.packageInfos && product.packageInfos.length>0">
                    <label>套　餐</label>
                    <div class="content parkpage-items">

                        <div :class="{active:product.id === item.id}" @click="choicePackage(item)" v-for="item in product.packageInfos">
                            {{item.name}}
                            <span style="color: #dc1d20; float: right;">{{ getPriceType(item.priceType).symbol }} {{item.price}}</span>
                        </div>

                    </div>
                </div>
                <div class="row rowflex" v-if="product.type ===2 && product.productInfos && product.productInfos.length>0">
                    <label>产  品</label>
                    <div class="content parkpage-items">

                        <div :class="{active:product.id === item.id}" @click="choicePackage(item)" v-for="item in product.productInfos">
                            {{item.name}}
                            <span style="color: #dc1d20; float: right;">{{ getPriceType(item.priceType).symbol }} {{item.price}}</span>
                        </div>

                    </div>
                </div>
                <div class="row rowflex" v-if="product.type ===1 && product.specs && product.specs.length>0">
                    <label>规　格</label>
                    <div class="content parkpage-items">

                        <div :class="{active:product.id === item.productId}" 
                            @click="choiceSpecs(item)" 
                            v-for="item in product.specs"
                            style="display: inline-block; vertical-align: top; margin:0 8px 0 0;"
                        >
                            {{item.specsValue}}
                        </div>

                    </div>
                </div>
                <div class="row parkpage rowflex" v-if="product.isActive">
                    <label>数　量</label>
                    <div class="content">
                        <el-input-number v-model="num" @change="handleChange" :min="1" :max="100000"></el-input-number>
                        (库存{{product.virtualStock}}件)
                    </div>
                </div>
                <div class="row parkpage rowflex" v-if="product.isActive">
                    <label></label>
                    <div class="content btns">
                        <button class="addCar" @click="addToCart">加入购物车</button>
                        <button class="buy"
                                @click="$router.push({ path:'/shoppingcart', query:{id: product.id, num:num}})">立即购买
                        </button>
                    </div>
                </div>
                <div class="row parkpage rowflex" v-if="!product.isActive">
                    <label></label>
                    <div class="content btns">
                        <button class="noSale">商品已下架</button>
                    </div>
                </div>
                <div class="row rowflex beforeSale" v-if="false">
                    <label></label>
                    <div class="content btns">
                        <button class="beforeSaleBtn">即将开始</button>
                        <span>距离开售还剩3小时20分23秒</span>
                    </div>
                </div>
            </div>
        </div>

        <!--<div class="hot">
            <span>套餐内容</span>
        </div>
        <div class="detail-items clearfix">
            <div class="item" v-for="i in 4">
                <router-link :to="{path:'/transaction/'+i}">
                    <img src="../../assets/frontend/images/img_2@2x.png" alt=""/>
                    <div class="title">产品名称产品名称产品名称产品名称产品名称产品名称</div>
                    <div class="price">$1235.22</div>
                </router-link>
            </div>
        </div>-->

        <div class="hot">
            <span>详细介绍</span>
        </div>
        <div class="detail" v-html="product.desc">
        </div>

        <div class="hot">
            <span>热卖推荐</span>
        </div>
        <div class="hot-items clearfix">
            <div class="item" v-for="item in hotSales">
                <router-link :to="{path:'/transaction/'+item.id}">
                    <img :src="item.imageUrl" alt=""/>
                    <div class="title">{{item.name}}</div>
                    <div class="price">{{ getPriceType(item.priceType).symbol }}{{item.price}}</div>
                </router-link>
            </div>
        </div>
        <div class="watchword">
            <img src="../../assets/frontend/images/pingzhi@2x.jpg" alt=""/>
        </div>

        <el-dialog
            title=""
            :visible.sync="addToCartTipsVisible"
            width="30%" custom-class="shopcard_dialog"
            center>
            <div class="addCarTips">
                <i class="el-icon-check"></i>
                <span>商品已成功加入购物车</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="jxgw" @click="addToCartTipsVisible = false">继续购物</button>
                <button class="ckgwc" @click="$router.push({path:'/shoppingcart'})">查看购物车</button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    let loading
    import shopCart from '@/js/mixins/shopCart.js'
    export default {
        name: 'product',
        mixins: [shopCart],
        data () {
            return {
                num: 1,
                loading: true,
                addToCartTipsVisible: false,
                currImage: '',
                product: {
                    id: 0,
                    options: []
                },
                hotSales: []
            }
        },
        created () {
            this.init()
        },
        mounted () {

        },
        watch: {
            '$route' () {
                this.init()
            },
        },
        methods: {
            init () {
                this.product.id = this.$route.params.id
                this.showPcLoading()
                this.getProduct()
                this.getHotSale()
            },
            getProduct () {
                this.axios.get(window.consts.apis.product + '?id=' + this.product.id).then(res => {
                    this.hidePcLoading()
                    if (res.success) {
                        this.product = res.result
                        this.setWindowTitle(this.product.name)
                        this.currImage = this.product.imageUrls[0]

                        let options = []
                        for (let key in this.product.options) {
                            options.push({ key: key, value: this.product.options[key] })
                        }
                        this.product.options = options

                    } else {
                        this.$alert(res.error.message, '')
                    }
                }).catch(res => {
                    this.hidePcLoading()
                })
            },
            getHotSale () {
                this.$axios.post(window.consts.apis.products, {
                    'hotSale': true,
                    'page': 1,
                    'size': 8
                }).then(res => {
                    if (res.success) {
                        this.hotSales = res.result.items
                    }
                })
            },
            choicePackage(item){
                if(item.id !== this.product.id){
                    this.$router.push({path:'/transaction/'+item.id});
                }
            },
            choiceSpecs(item) {
                if(item.productId !== this.product.id){
                    this.$router.push({path:'/transaction/'+item.productId});
                }
            },
            addToCart () {
                if (!this.product.name) {
                    return //产品未加载成功
                }

                //数据库购物车

                let id = this.product.id
                let num = this.num
                let temp = { 
                    commodityId: id, 
                    quantity: num
                }
                let user = this.$store.state.user;
                if (user && user.id && user.id > 0) {
                    this._addToCart({ commodityId: id, quantity: num }).then(res=>{
                        if(res.success){
                            if (this.setShopCartLocalStorage(temp)) {
                                this.addToCartTipsVisible = true
                            }
                        }else{
                            this.$alert(res.error.message,'')
                        }
                    }).catch(e=>{
                        this.$message.error("出错啦，请稍候再试!")
                    });
                } else {
                    if (this.setShopCartLocalStorage(temp)) {
                        this.addToCartTipsVisible = true
                    }
                }
                return ;
                /*let items=[]; // 购物车的结构 [{id: id, num: num }]
                let cartVal = localStorage.getItem(window.consts.strings.cart) //获取购物车的数据
                if (cartVal) {
                    items = JSON.parse(cartVal);
                }
                let item = items.filter(x => {
                    return x.id === id
                });
                if(item.length>0)
                {
                    for(let i =0;i<items.length;i++){
                        if(items[i].id === id){
                            items[i].num++;
                        }
                    }
                }else {
                    items.push({ id: id, num: num })
                }
                localStorage.setItem(window.consts.strings.cart, JSON.stringify(items))
                this.addToCartTipsVisible = true*/
            },
            handleChange (value) {
                console.log(value)
            }
        }
    }
</script>
